export default {
  size: {
    xsmall: '8px',
    small: '12px',
    medium: '24px',
    large: '64px',
    xlarge: '96px'
  }
}
